//import Light from "light";
//import {jQuery} from "./jshead.js";
//var domain="typaimai.com";
//var domain="hshs.exp";
//var domain="typaimai.test";
//var domain="e.hsyunyong.com";
var domain=AppConfig.url.domainUrl;

//环境
var mobileGoodsDetailUrl = AppConfig.url.mobileGoodsDetailUrl+"/#/goods/goods_physical_detail?goodsCode=";
//var mobileGoodsDetailUrl = "http://momall."+domain+"/#/goods/goods_physical_detail?goodsCode=";
//UAT环境
//var mobileGoodsDetailUrl = "http://m-mall-uat."+domain+"/#/goods/goods_physical_detail?goodsCode=";

function getAboutUsUrl(){
	//测试环境
	//return "http://www.yibaobuy.com:28020/abount/629.htm";
	//生产环境
	return AppConfig.url.cmsUrl+"/aboutus/index.htm";
}
function getIndexUrl(){
	//测试环境
	//return "http://mall."+domain;
	//生产环境
	//	return "http://cms.91yyzx.cn";
	//UAT环境
	//return "http://mall-uat."+domain;
	return AppConfig.url.indexUrl;
}
function getCmsUrl(){
	//测试环境
	//return "http://mall."+domain;
	//生产环境
	//	return "http://cms.91yyzx.cn";
	//UAT环境
	//return "http://mall-uat."+domain;
	return AppConfig.url.cmsUrl;
}
function getUcUrl(){
	//开发环境
	//return "http://uc."+domain;
	//测试环境
	//return "http://uc."+domain;
	//生产环境
	//return "http://euc."+domain;
	//UAT环境
	//return "http://euc-uat."+domain;
	return AppConfig.url.ucUrl;
}
//东北商品
//var ajaxUrl = "http://emall.91yyzx.cn";
//香港收藏品
//ajaxUrl = "http://emall.yibaobuy.com";
//测试环境
//var ajaxUrl = "http://emall."+domain;
//UAT环境
//var ajaxUrl = "http://emall-uat."+domain;
var ajaxUrl = AppConfig.url.ajaxUrl;
//采购商服务
var purchaserUrl = AppConfig.url.purchaserUrl;
//品牌导航
var brandUrl = AppConfig.url.brandUrl;
//需求中心
var requirementUrl = AppConfig.url.requirementUrl;
//交易大厅
var tradingHallUrl = AppConfig.url.tradingHallUrl;
//新闻百科
var newsUrl = AppConfig.url.newsUrl;
//展会
var exhibitionUrl = AppConfig.url.exhibitionUrl;
/**
 * 
 */
function getAjaxUrl() {
//return "http://emall.hsnsfe.dev/mobile";
//测试环境
//return "http://emall."+domain+"/mobile";
//生产环境
//return "http://emall.91yyzx.cn/mobile";
//UAT环境
//return "http://emall-uat."+domain+"/mobile";
return AppConfig.url.ajaxUrl+"/mobile";
}

function getImgUrl() {
//return "http://emall.hsnsfe.dev";
//测试环境
//return "http://emall."+domain;
//生产环境
//return "http://emall.91yyzx.cn";
//UAT环境
//return "http://emall-uat."+domain;
return AppConfig.url.imgUrl;
}

function getEmallUrl() {
//测试环境
//return "http://emall."+domain;
//生产环境
//return "http://emall.91yyzx.cn";
//UAT环境
//return "http://emall.yibaobuy.com";
//return "http://emall-uat."+domain;
return AppConfig.url.emallUrl;
}

function getMallUrl() {
//测试环境
//return "http://emall."+domain;
//生产环境
//return "http://emall.91yyzx.cn";
//UAT环境
//return "http://emall.yibaobuy.com";
//return "http://emall-uat."+domain;
//console.log("mallUrl"+AppConfig.url.mallUrl);
return AppConfig.url.mallUrl;
}

//联系客服链接
var sysContactUrl = AppConfig.url.contactUrl;//"http://wpa.qq.com/msgrd?v=3&uin=1850908193&site=qq&menu=yes";

//默认产品小图
var defaultSmallImg = "images/goods/defaultSmallImg.jpg";
var defaultMiddleImg = "images/goods/defaultMiddleImg.jpg";
var cmsApiUrl = AppConfig.url.cmsUrl+"/api/index.htm";

/**
 * 返回页面地址
 * @param {Object} url
 */
function getUrl(url) {
	var domain = sessionStorage.getItem("domain");
	if(domain == undefined || domain == null || domain == 'null') {
		return url;
	} else {
		if(url != undefined && url != null) {
			if(url.indexOf("http") == 0) {
				return url;
			}
			if(domain.lastIndexOf("/") < domain.length - 1) {
				domain += "/"
			}
			if(url.indexOf("/") == 0) {
				url = url.substring(1, url.length);
			}
			return domain + url;
		} else {
			return domain;
		}
	}
}

function getAdsList() {
	var imgUrls = new Array();
	var imgUrl1 = { 'imgUrl': 'images/temp/lb1.jpg' };
	var imgUrl2 = { 'imgUrl': 'images/temp/lb2.jpg' };
	var imgUrl3 = { 'imgUrl': 'images/temp/lb3.jpg' };
	imgUrls[0] = imgUrl1;
	imgUrls[1] = imgUrl2;
	imgUrls[2] = imgUrl3;
	return imgUrls;
}

/**
 * 占位符替换
 * @returns
 */
function StringFormat() {
	if(arguments.length == 0)
		return this;
	var str = arguments[0];
	for(var i = 1; i < arguments.length; i++) {
		var re = new RegExp('\\{' + (i - 1) + '\\}', 'gm');
		str = str.replace(re, arguments[i]);
	}
	return str;
}

/**
 * 获取地址栏参数
 */
function GetQueryString(name) {
	var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
	var r = window.location.search.substr(1).match(reg);
	if(r != null) return unescape(r[2]);
	return null;
}

/**
 * 权限控制
 */
function isPermission() {

}

/**
 * 是否使用微信内置浏览器
 */
function isWeiXin() {
	var ua = window.navigator.userAgent.toLowerCase();
	if(ua.match(/MicroMessenger/i) == 'micromessenger') {
		return true;
	} else {
		return false;
	}
}

function saveDomain() {
	var curUrl = window.location.href;
	if(curUrl != undefined && curUrl.length > 0) {
		var curDomain = curUrl.substring(0, curUrl.indexOf("/loading") + 1);
		if(curDomain == undefined || curDomain == '') {
			var curDomain = curUrl.substring(0, curUrl.indexOf("/index") + 1);
		}
		if(curDomain == undefined || curDomain == '') {
			var curDomain = curUrl.substring(0, curUrl.indexOf("/model") + 1);
		}
		sessionStorage.setItem("domain", curDomain);
	}
}

/**
 * &#123456;转中文
 * @param {Object} str 输入字符串
 */
function unicode2chs(str) {
	if(str == undefined || str.length == 0) {
		return "";
	}
	var reg = /\d{5}/gi;
	var result = "";
	var strArr = str.match(reg);
	if(strArr == undefined || strArr == null || strArr.length == 0) {
		return str;
	}
	for(i in strArr) {
		decStr = strArr[i];
		hexStr = parseInt(decStr).toString(16);
		result += '%u' + hexStr;
	}
	return unescape(result);
}

//jQuery(document).ready(function() {
//	saveDomain();
//})

/**
 * 获取cookie，解决cookie为空问题，IOS微信使用，经过跳转添加token=1参数
 */
function getWxCookie() {
	var backUrl = window.location.href;
	if(backUrl.indexOf("token=1") < 0) {
		backUrl = encodeURIComponent(backUrl);
		var serverUrl = getAjaxUrl() + "/home/get_token.htm";
		window.location.href = serverUrl + "?backurl=" + backUrl;
	}
}

function isNotBlank(str) {
	if (typeof(str) != 'string') {
		return false;
	}
	if (str == undefined || str == null || str.trim() == '') {
		return false;
	}
	return true;
}
function isBlank(str) {
	return ! isNotBlank(str);
}

var EnumPointType = {
	'point': '通用积分',
	'special': '专用积分',
	'red': '红积分',
	'blue': '蓝积分'
}
//获取积分名称
function getPointTypeName(pointType){
	if(pointType=="point"){
		return "积分";
	}
}

function stringUtilsSplit(str,length){
	if(str.length>length){
		return str.substring(0,length)+"...";
	}else{
		return str;
	}
	
}

 /**
 * 解析结果
 * @param {Object} result 返回结果
 * @param {Object} errMsg 错误提示信息
 * @param {Object} redirect 错误返回地址
 */
function parseResult(result, errMsg, redirect) {
	if (result == undefined) {
		return false;
	}
	if (result.code != undefined && result.code == '9999') {
//			Light.navigate("login/login",{
//				backUrl:redirect
//			});
			alert("您暂无权限！");
		return false;
	}
	if (result.code != undefined && result.code == 'fail') {
		if (errMsg == undefined || errMsg == null) {
			if (result.msg != undefined && result.msg != null) {
				errMsg = result.msg;
			} else {
				errMsg = "系统繁忙，请稍后再试";
			}
		} 
//		alert(errMsg);
		/*mui.confirm(errMsg,'提示',['确定'],function(e){
			if (redirect != false) {
				if (redirect != undefined && redirect != null) {
					window.location.href = redirect;
				} else {
					window.history.go(-1);
				}
			}
		});*/
		return false;
	}
	if (result.code != undefined && result.code == 'goodsNumFail') {
		if (errMsg == undefined || errMsg == null) {
			if (result.msg != undefined && result.msg != null) {
				errMsg = result.msg;
			} else {
				errMsg = "系统繁忙，请稍后再试";
			}
		}
		/*mui.confirm(errMsg,'提示',['确定'],function(e){
			
		});*/
//		alert(errMsg);
		return false;
	}
	if (result.code != undefined && result.code != 'success') {
		if (result.msg == undefined || result.msg == null) {
			errMsg = "系统繁忙，请稍后再试";
		} else {
			errMsg = result.msg;
		}
		/*mui.confirm(errMsg,'提示',['确定'],function(e){
			if (redirect != false) {
				if (redirect != undefined && redirect != null) {
					window.location.href = redirect;
				} else {
					window.history.go(-1);
				}
			}
		});*/
//		alert(errMsg);
		return false;
	}
	return true;
}

var emallTitle="积分商城";//商城标题
var showCoupon=false;//是否显示 促销券
var showCabinet=true;//是否展示橱窗
var showNavicate=true;//是否展示分类导航
var showMoney=true;//是否显示金额

function dateFormat(dateStr){
	var showTime = "";
	if (dateStr.length == 14) {
		showTime += dateStr.substring(0,4) + "-";
		showTime += dateStr.substring(4,6) + "-";
		showTime += dateStr.substring(6,8) + " ";
		showTime += dateStr.substring(8,10) + ":";
		showTime += dateStr.substring(10,12) + ":";
		showTime += dateStr.substring(12,14);
	}
	return showTime;
}

function getValueFromMap(enumMap,enumKey){
	var jsonStr =  JSON.stringify(enumMap);
    var jsonObject = JSON.parse(jsonStr);
    var enumValue = jsonObject[enumKey];
    return enumValue;
}

function Map() {   
      this.elements = new Array();     
         
      //获取MAP元素个数     
      this.size = function() {     
          return this.elements.length;     
      }     
         
      //判断MAP是否为空     
      this.isEmpty = function() {     
          return(this.elements.length < 1);     
      }     
         
      //删除MAP所有元素     
      this.clear = function() {     
          this.elements = new Array();     
      }     
         
      //向MAP中增加元素（key, value)      
      this.put = function(_key, _value) {     
          this.elements.push( {     
              key : _key,     
              value : _value     
          });     
      }     
         
      //删除指定KEY的元素，成功返回True，失败返回False     
      this.remove = function(_key) {     
          var bln = false;     
          try{     
              for(var i = 0; i < this.elements.length; i++) {     
                  if(this.elements[i].key == _key) {     
                      this.elements.splice(i, 1);     
                      return true;     
                  }     
              }     
          } catch(e) {     
              bln = false;     
          }     
          return bln;     
      }     
         
      //获取指定KEY的元素值VALUE，失败返回NULL     
      this.get = function(_key) {     
          try{     
              for(var i = 0; i < this.elements.length; i++) { 
                  if(this.elements[i].key == _key) {     
                      return this.elements[i].value;     
                  }     
              }     
          } catch(e) {     
              return null;     
          }     
      }     
         
      //获取指定索引的元素（使用element.key，element.value获取KEY和VALUE），失败返回NULL     
      this.element = function(_index) {     
          if(_index < 0 || _index >= this.elements.length) {     
              return null;     
          }     
          return this.elements[_index];     
      }     
         
      //判断MAP中是否含有指定KEY的元素     
      this.containsKey = function(_key) {     
          var bln = false;     
          try{     
              for(var i = 0; i < this.elements.length; i++) {     
                  if(this.elements[i].key == _key) {     
                      bln = true;     
                  }     
              }     
          } catch(e) {     
              bln = false;     
          }     
           return bln;     
       }     
          
       //判断MAP中是否含有指定VALUE的元素     
       this.containsValue = function(_value) {     
           var bln = false;     
           try{     
               for(var i = 0; i < this.elements.length; i++) {     
                   if(this.elements[i].value == _value) {     
                       bln = true;     
                   }     
               }     
           } catch(e) {     
               bln = false;     
           }     
           return bln;     
       }     
          
       //获取MAP中所有VALUE的数组（ARRAY）     
       this.values = function() {     
           var arr = new Array();     
           for(var i = 0; i < this.elements.length; i++) {     
               arr.push(this.elements[i].value);     
           }     
           return arr;     
       }     
          
       //获取MAP中所有KEY的数组（ARRAY）     
       this.keys = function() {     
           var arr = new Array();     
           for(var i = 0; i < this.elements.length; i++) {     
               arr.push(this.elements[i].key);     
           }     
           return arr;     
       }     
   }
// 说明：两个时间相减
// 参数：JS的Date类型，或者 string 类型，格式为：yyyy-MM-dd HH:mm:ss
// 返回: date1-date2的秒数
function compareDate(date1,date2){
    var type1 = typeof date1;
    var type2 = typeof date2;
    if (type1 == 'string')
    {
        date1 = new Date(date1);
    }
    if (type2 == 'string')
    {
        date2 = new Date(date2);
    }
    return (date1 - date2) / 1000;
}

//百度地图Ak
var ak = "AHTQQIz1IKN3P0BfojMHzH4GHkHt1Wyx";
export{
	getEmallUrl,
	getMallUrl,
	getAboutUsUrl,
	getUcUrl,
	getIndexUrl,
	getImgUrl,
	getCmsUrl,
	getAjaxUrl,
	getAdsList,
	dateFormat,
	getValueFromMap,
	showMoney,getFooterUrl,
	parseResult,
	EnumPointType,
	defaultMiddleImg,
	defaultSmallImg,
	Map,
	GetQueryString,
	isWeiXin,
	ajaxUrl,
	compareDate,
	sysContactUrl,
	ak,
	mobileGoodsDetailUrl,
	cmsApiUrl,
	purchaserUrl,
	brandUrl,
	requirementUrl,
	tradingHallUrl,
	newsUrl,
	exhibitionUrl
};



// WEBPACK FOOTER //
// ./static/js/emallUtils.js